import type { Config } from 'eslint/config';
import { testsRulesConfig } from '../rules/index.js';

export const testsConfig: Config[] = [testsRulesConfig];
